import { MemberInfoFragment } from '@/graphql/fragments';
import { gql } from 'graphql-tag';

export const SessionInfoFragment = gql`
  ${MemberInfoFragment}
  fragment SessionInfo on SessionType {
    eventId
    locationId
    sessionStartTimestamp
    skuId
    studyId
    paymentMethod
    promoCode
    discountDetails {
      actor
      promoID
      name
      amount
      type
      validLocations
      validSkus
      formattedBanner
    }
    billingInformation {
      address
      city
      country
      postalCode
      state
    }
    member {
      ...MemberInfo
    }
    timeSlot {
      machineId
      utcEnd
      utcStart
    }
  }
`;
